@use "sass:string";

$top-nav-height: 50px;
$main-nav-height: 56px;
$mobile-nav-height: 64px;
// Perhaps not the best place for this to live, but this is the spot that lets
// us define it once and use it everywhere
$main-content-id: "main-content";

:root {
    // related to TopNav
    --top-nav-height: 0px;
    // related to Main and Mobile navs overlapping content based on the type
    // of the first body block
    --overlappable-nav-height: #{$main-nav-height};
}

:root:has([data-top-nav]) {
    --top-nav-height: #{$top-nav-height};
}

:root:has([data-mobile-layout]) {
    --overlappable-nav-height: #{$mobile-nav-height};
}

:root:has([data-overlapping]) :global(##{$main-content-id}) {
    margin-top: calc(-1 * var(--overlappable-nav-height));
}

.nav {
    display: contents;
}

:export {
    mainNavHeight: $main-nav-height;
    mainContentId: string.unquote($main-content-id);
}
